import { useState } from "react";
import MagnifyingGlass from "../../../../assets/icons/magnifying-glass-small-gray.svg";
import { Popover, PopoverContent, PopoverTrigger } from "../../../../components/popover";
import type TableFilterState from "../../../../components/customs/table-header/table-filter-state";
import { DatePickerV3 } from "../../../../components/date-picker-v3";
import NumberFilter from "../../../../components/customs/number-filter";
import type { UserFilters } from "../../types/user.types";

type StablePopoverAgeOrDateOfBirthFilterProps = {
  filterState: TableFilterState<UserFilters>;
  placeholder?: string | null;
  title?: string | null;
  description?: string | null;
  isOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  onEnter?: (value: string) => void;
};

const StablePopoverAgeOrDateOfBirthFilterComponent = ({
  filterState,
  description,
  isOpen,
  onOpenChange,
}: StablePopoverAgeOrDateOfBirthFilterProps) => {
  const [internalOpen, setInternalOpen] = useState(false);

  const controlledOpen = isOpen !== undefined ? isOpen : internalOpen;
  const controlledOnOpenChange = onOpenChange || setInternalOpen;

  const handleOpenChange = (newOpen: boolean) => {
    controlledOnOpenChange(newOpen);
  };

  return (
    <Popover
      open={controlledOpen}
      onOpenChange={handleOpenChange}
    >
      <PopoverTrigger asChild>
        <img
          className="ml-2 w-3 cursor-pointer"
          src={MagnifyingGlass}
          alt="Search"
        />
      </PopoverTrigger>
      <PopoverContent className="w-64 p-2">
        <NumberFilter
          value={filterState.filter.age}
          onApply={(val) =>
            filterState.setFilter((prev) => ({
              ...prev,
              age: val,
              date_of_birth: null,
            }))
          }
          onClear={() =>
            filterState.setFilter((prev) => ({
              ...prev,
              age: null,
            }))
          }
          onChange={() => undefined}
          placeholder="Search age..."
          title="Filter by age"
        />
        <div className="relative flex items-center w-full">
          <div className="flex-grow border-t border-gray-200" />
          <span className="mx-2 text-xs text-gray-400 select-none uppercase">or</span>
          <div className="flex-grow border-t border-gray-200" />
        </div>
        <div>
          <span className="block my-[10px] mx-[5px] uppercase text-xs text-[#6A7282]">
            Filter by date of birth
          </span>
          <DatePickerV3
            value={filterState.filter.date_of_birth ?? undefined}
            onChange={(date) =>
              filterState.setFilter((prev) => ({ ...prev, age: null, date_of_birth: date ?? null }))
            }
            placeholder="Select DOB..."
            className="w-full"
          />
          <span className="block m-[5px] text-[9px] text-[#959595]">{description || null}</span>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default StablePopoverAgeOrDateOfBirthFilterComponent;
